import { render, staticRenderFns } from "./customerpushlog0512archive.vue?vue&type=template&id=54b66552&"
import script from "./customerpushlog0512archive.vue?vue&type=script&lang=js&"
export * from "./customerpushlog0512archive.vue?vue&type=script&lang=js&"
import style0 from "./customerpushlog0512archive.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports